<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-4': $vuetify.breakpoint.mdAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.smAndDown}">
                    <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </router-link>
                    <router-link to="/prize_shop">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-2" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ $t("Каталог призов") }}
                        </v-breadcrumbs-item>
                    </router-link>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-3" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ $t("Мои заказы") }}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <div style="display: flex; justify-content: space-between; align-items: center">
                    <h1 style="cursor: default" class="section-title-main my-3 mr-4 font-weight-regular" :class="{'px-3': $vuetify.breakpoint.smAndDown}">{{ $t("Мои заказы") }}</h1>
                </div>
                <Prize_shop_order />
            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import Prize_shop_order from '@/components/view_blocks/Prize_shop/Prize_shop_order';
export default {
  components: {
    HeaderMenu, UserMenu, FooterBlock, Prize_shop_order,
  },
};
</script>

<style scoped>

</style>
